export const SITE_ICONS = [
    "akar-icons:jar",
    "carbon:category",
    "carbon:cost-total",
    "carbon:customer",
    "carbon:location",
    "carbon:location-filled",
    "circum:lemon",
    "cryptocurrency:bnb",
    "cryptocurrency:btc",
    "cryptocurrency:eth",
    "cryptocurrency:sol",
    "cryptocurrency:trx",
    "cryptocurrency:usdt",
    "dashicons:star-empty",
    "dashicons:star-filled",
    "dashicons:star-half",
    "file-icons:mint",
    "fluent-emoji-high-contrast:blueberries",
    "fluent-emoji-high-contrast:butter",
    "fluent:chevron-12-filled",
    "fluent:chevron-down-20-regular",
    "fluent:chevron-right-16-regular",
    "fluent:chevron-up-down-20-regular",
    "fluent:gas-24-filled",
    "fluent:image-edit-16-regular",
    "fluent:shifts-activity-20-regular",
    "game-icons:grapes",
    "game-icons:heat-haze",
    "game-icons:milk-carton",
    "game-icons:orange",
    "game-icons:pineapple",
    "game-icons:raspberry",
    "game-icons:strawberry",
    "healthicons:fruits-outline",
    "hugeicons:tea",
    "ic:baseline-delivery-dining",
    "ic:baseline-facebook",
    "ic:baseline-minus",
    "ic:baseline-plus",
    "ic:baseline-whatsapp",
    "ic:outline-label",
    "icon-park-outline:expenses",
    "icon-park-outline:honey",
    "iconoir:soil",
    "lets-icons:order",
    "line-md:file-upload",
    "logos:google-icon",
    "logos:google-maps",
    "logos:mastercard",
    "logos:visa",
    "lucide:cherry",
    "lucide:citrus",
    "material-symbols-light:cookie-outline",
    "material-symbols-light:point-of-sale",
    "material-symbols-light:search",
    "material-symbols:account-balance-outline",
    "material-symbols:add",
    "material-symbols:add-circle-outline-rounded",
    "material-symbols:add-rounded",
    "material-symbols:analytics",
    "material-symbols:arrow-back-rounded",
    "material-symbols:assignment-return",
    "material-symbols:assignment-returned",
    "material-symbols:attach-money",
    "material-symbols:auto-awesome",
    "material-symbols:background-replace-outline",
    "material-symbols:bolt",
    "material-symbols:calculate-outline",
    "material-symbols:call-split",
    "material-symbols:category-outline",
    "material-symbols:check-circle",
    "material-symbols:check-rounded",
    "material-symbols:chevron-right",
    "material-symbols:close",
    "material-symbols:cloud-upload-outline",
    "material-symbols:content-copy",
    "material-symbols:content-copy-outline",
    "material-symbols:cookie-rounded",
    "material-symbols:credit-card-outline",
    "material-symbols:delete",
    "material-symbols:delete-outline",
    "material-symbols:delete-outline-rounded",
    "material-symbols:description",
    "material-symbols:description-outline",
    "material-symbols:error-outline",
    "material-symbols:expand-more",
    "material-symbols:group",
    "material-symbols:group-off",
    "material-symbols:home",
    "material-symbols:hourglass-top",
    "material-symbols:image-outline",
    "material-symbols:info-outline",
    "material-symbols:insights",
    "material-symbols:inventory",
    "material-symbols:inventory-2",
    "material-symbols:list-alt-outline",
    "material-symbols:mail-outline",
    "material-symbols:man",
    "material-symbols:mark-email-read-outline",
    "material-symbols:menu",
    "material-symbols:overview",
    "material-symbols:payments-outline",
    "material-symbols:percent",
    "material-symbols:person",
    "material-symbols:person-add",
    "material-symbols:person-remove",
    "material-symbols:print-outline",
    "material-symbols:qr-code-2",
    "material-symbols:receipt-long-outline",
    "material-symbols:remove-rounded",
    "material-symbols:search",
    "material-symbols:search-off",
    "material-symbols:send",
    "material-symbols:shopping-bag-outline",
    "material-symbols:spa",
    "material-symbols:sync-alt-rounded",
    "material-symbols:travel-explore",
    "material-symbols:undo",
    "mdi:account-alert",
    "mdi:account-cancel",
    "mdi:account-multiple",
    "mdi:account-outline",
    "mdi:account-plus-outline",
    "mdi:account-search",
    "mdi:alert-circle",
    "mdi:arrow-left",
    "mdi:bank-transfer",
    "mdi:bitcoin",
    "mdi:car",
    "mdi:cart",
    "mdi:cash-multiple",
    "mdi:chart-bar",
    "mdi:chart-pie",
    "mdi:check",
    "mdi:check-circle",
    "mdi:check-circle-outline",
    "mdi:chevron-down",
    "mdi:chevron-left",
    "mdi:close",
    "mdi:connection",
    "mdi:content-copy",
    "mdi:credit-card",
    "mdi:credit-card-off",
    "mdi:crown",
    "mdi:currency-btc",
    "mdi:currency-chf",
    "mdi:currency-eur",
    "mdi:currency-gbp",
    "mdi:currency-usd",
    "mdi:do-not-disturb-alt",
    "mdi:earth-off",
    "mdi:file-document-check-outline",
    "mdi:hand-back-right-off",
    "mdi:human-pregnant",
    "mdi:image-plus",
    "mdi:information-outline",
    "mdi:instagram",
    "mdi:key-remove",
    "mdi:lan-disconnect",
    "mdi:lightbulb-on",
    "mdi:lock-alert",
    "mdi:lock-reset",
    "mdi:login",
    "mdi:logout",
    "mdi:magnify",
    "mdi:magnify-scan",
    "mdi:menu",
    "mdi:peanut",
    "mdi:pine-tree",
    "mdi:printer",
    "mdi:printer-pos-outline",
    "mdi:qrcode-scan",
    "mdi:robot",
    "mdi:robot-angry",
    "mdi:sale",
    "mdi:scent",
    "mdi:shield-alert",
    "mdi:shield-lock",
    "mdi:shield-off",
    "mdi:skull-crossbones",
    "mdi:smoking",
    "mdi:speedometer-slow",
    "mdi:spicy",
    "mdi:store",
    "mdi:swap-horizontal",
    "mdi:trash-can-outline",
    "mdi:trophy",
    "mdi:view-dashboard-outline",
    "mingcute:line-app-line",
    "mingcute:lollipop-fill",
    "ph:cloud-sun",
    "ph:moon",
    "ph:orange-light",
    "ph:sticker",
    "ph:sun",
    "ri:currency-line",
    "ri:whatsapp-fill",
    "simple-icons:googlemaps",
    "simple-line-icons:check",
    "solar:alt-arrow-down-linear",
    "solar:arrow-down-outline",
    "solar:arrow-left-linear",
    "solar:arrow-right-linear",
    "solar:arrow-right-outline",
    "solar:arrow-right-up-linear",
    "solar:arrow-up-outline",
    "solar:backspace-outline",
    "solar:bolt-circle-bold",
    "solar:buildings-outline",
    "solar:calculator-outline",
    "solar:camera-add-outline",
    "solar:card-outline",
    "solar:card-transfer-outline",
    "solar:cart-4-bold",
    "solar:cart-4-outline",
    "solar:cart-check-bold-duotone",
    "solar:cart-cross-bold-duotone",
    "solar:cart-large-2-bold",
    "solar:chart-bold",
    "solar:chart-outline",
    "solar:chart-square-outline",
    "solar:check-circle-bold",
    "solar:check-circle-outline",
    "solar:checklist-minimalistic-outline",
    "solar:clock-circle-outline",
    "solar:close-circle-bold",
    "solar:close-circle-linear",
    "solar:cloud-upload-outline",
    "solar:crown-outline",
    "solar:danger-circle-bold",
    "solar:danger-triangle-outline",
    "solar:delivery-bold-duotone",
    "solar:document-medicine-outline",
    "solar:document-text-outline",
    "solar:dollar-outline",
    "solar:download-outline",
    "solar:home-2-bold",
    "solar:info-circle-bold",
    "solar:info-circle-outline",
    "solar:leaf-bold",
    "solar:leaf-outline",
    "solar:link-circle-outline",
    "solar:list-check-outline",
    "solar:lock-keyhole-minimalistic-bold",
    "solar:lock-keyhole-outline",
    "solar:map-point-bold-duotone",
    "solar:mouse-linear",
    "solar:phone-outline",
    "solar:printer-bold",
    "solar:printer-outline",
    "solar:refresh-circle-bold",
    "solar:refresh-circle-outline",
    "solar:restart-outline",
    "solar:scooter-bold-duotone",
    "solar:settings-outline",
    "solar:share-outline",
    "solar:shield-check-outline",
    "solar:shop-2-outline",
    "solar:shop-bold",
    "solar:shop-outline",
    "solar:star-bold",
    "solar:star-outline",
    "solar:upload-outline",
    "solar:user-circle-outline",
    "solar:users-group-rounded-outline",
    "solar:wad-of-money-bold-duotone",
    "solar:wallet-bold",
    "solar:wallet-outline",
    "streamline-cyber:cannabis-leaf",
    "svg-spinners:180-ring-with-bg",
    "svg-spinners:90-ring-with-bg",
    "tabler:lemon",
    "tdesign:candy",
    "tdesign:garlic",
    "tdesign:member"
];
